// DO NOT EDIT -- generated from fs/services/search-settings/alertconfigs.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as proactiveinsights from '../../api/proactiveinsights';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

export namespace AlertConfigs {

  export const GetAllAlertConfigsEndpoint = "/grpc/search_settings.AlertConfigs/GetAllAlertConfigs";
  /**
   * Get all current non-archived alert configs for an org.
   * If desired, archived alert configs can also be retrieved with the explicit request flag.
   * If desired, alert configs can be filtered based on the Dx Object it is associated with.
   */
  export function GetAllAlertConfigs(sender: (req: GetAllAlertConfigsRequest, endpoint: string) => Promise<GetAllAlertConfigsResponse>, req: GetAllAlertConfigsRequest): { promise: () => Promise<GetAllAlertConfigsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllAlertConfigsEndpoint),
      endpoint: GetAllAlertConfigsEndpoint
    };
  }

  export const GetAlertConfigEndpoint = "/grpc/search_settings.AlertConfigs/GetAlertConfig";
  /** Get a specific AlertConfig, either current or past version. */
  export function GetAlertConfig(sender: (req: GetAlertConfigRequest, endpoint: string) => Promise<GetAlertConfigResponse>, req: GetAlertConfigRequest): { promise: () => Promise<GetAlertConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAlertConfigEndpoint),
      endpoint: GetAlertConfigEndpoint
    };
  }

  export const SetAlertConfigEndpoint = "/grpc/search_settings.AlertConfigs/SetAlertConfig";
  /** Add a new AlertConfig or update an existing AlertConfig. */
  export function SetAlertConfig(sender: (req: SetAlertConfigRequest, endpoint: string) => Promise<SetAlertConfigResponse>, req: SetAlertConfigRequest): { promise: () => Promise<SetAlertConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetAlertConfigEndpoint),
      endpoint: SetAlertConfigEndpoint
    };
  }

  export const ArchiveAlertConfigEndpoint = "/grpc/search_settings.AlertConfigs/ArchiveAlertConfig";
  /**
   * Archive an existing AlertConfig for an org.
   * Once archived, the AlertConfig cannot be modified and will not show up in GetAllAlertConfig unless explicitly requested.
   */
  export function ArchiveAlertConfig(sender: (req: ArchiveAlertConfigRequest, endpoint: string) => Promise<ArchiveAlertConfigResponse>, req: ArchiveAlertConfigRequest): { promise: () => Promise<ArchiveAlertConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveAlertConfigEndpoint),
      endpoint: ArchiveAlertConfigEndpoint
    };
  }

  export const UnarchiveAlertConfigEndpoint = "/grpc/search_settings.AlertConfigs/UnarchiveAlertConfig";
  /**
   * Unarchives an existing AlertConfig for an org.
   * Once unarchived, the AlertConfig can continue to be modified and will show up in GetAllAlertConfig.
   */
  export function UnarchiveAlertConfig(sender: (req: UnarchiveAlertConfigRequest, endpoint: string) => Promise<UnarchiveAlertConfigResponse>, req: UnarchiveAlertConfigRequest): { promise: () => Promise<UnarchiveAlertConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveAlertConfigEndpoint),
      endpoint: UnarchiveAlertConfigEndpoint
    };
  }

  export const GetAlertConfigsAccessEndpoint = "/grpc/search_settings.AlertConfigs/GetAlertConfigsAccess";
  /** Retrieve information about the owner of a given DxObject and who can delete or edit it. */
  export function GetAlertConfigsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAlertConfigsAccessEndpoint),
      endpoint: GetAlertConfigsAccessEndpoint
    };
  }
}

export interface GetAllAlertConfigsRequest {
  orgId: string;
  /** If true, archived alert configs will also be returned. */
  includeArchived: boolean;
  /**
   * Specify this field to restrict the alerts down to specific DX Objects.
   * If this is used, SupportedDxObjectType is required.
   * Id and Version are optional. Though to specify Version, Id must be provided.
   */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
}

export interface GetAllAlertConfigsResponse {
  alertConfigs: AlertConfigRecord[];
}

export interface GetAlertConfigRequest {
  /** required */
  orgId: string;
  /** required */
  alertConfigId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetAlertConfigResponse {
  versions: AlertConfigRecord[];
}

export interface SetAlertConfigRequest {
  orgId: string;
  /** To create a new AlertConfig, leave id empty. To update an existing config, set the appropriate id. */
  alertConfig: proactiveinsights.AlertConfig | null;
}

export interface SetAlertConfigResponse {
  alertConfig: AlertConfigRecord | null;
}

export interface ArchiveAlertConfigRequest {
  orgId: string;
  alertConfigId: string;
}

export interface ArchiveAlertConfigResponse {
  alertConfig: AlertConfigRecord | null;
}

export interface UnarchiveAlertConfigRequest {
  orgId: string;
  alertConfigId: string;
}

export interface UnarchiveAlertConfigResponse {
  alertConfig: AlertConfigRecord | null;
}

export interface AlertConfigRecord {
  alertConfig: proactiveinsights.AlertConfig | null;
  metadata: protoauditstore.AuditMetadata | null;
}
